import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import Icon from '@ant-design/icons/lib/components/Icon';
import myIconWhite from '@public/images-mobile/game-room/my_icon.svg';
import MyIconBlack from '@public/images-mobile/game-room/my_icon_black.svg';
import styles from './styles';
import PlayerIcon from '@components/PlayerIcon';
import {CSSProperties} from 'react';
// import Poker from '@components/Poker';
// import classnames from 'classnames';

const PlayerAvatar = (props: {
  icon: JSX.Element | string;
  // eslint-disable-next-line react/no-unused-prop-types
  iconWidthPx?: number;
  className?: string;
  isBlackBorder?: boolean;
  isImagePreview?: boolean;
  style?: CSSProperties;
  isSelected?: boolean; // For profile settings icon selection
}): JSX.Element => {
  const {icon, className, isBlackBorder, isImagePreview, style, isSelected} = props;
  const {classes} = useCommon({
    withStyles: {styles, hasProps: true, props},
  });

  return (
    <div style={style} className={classNames(classes.playerIconContainer, className)}>
      <div className={isSelected ? classes.playerIconSelected : classes.playerIcon}>
        <div className={classes.playerIconInner}>
          <span className={classes.playerAvatar}>
            <PlayerIcon icon={icon} isImagePreview={isImagePreview} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlayerAvatar;
